import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

import { appConfig } from 'config/customization';

export const muiTheme = createMuiTheme({
  overrides: {
    MuiCheckbox: {
      colorSecondary: {
        '&$checked': {
          color: appConfig.colors.primary
        },
        '&$disabled': {
          color: appConfig.colors.disabledButton
        }
      }
    }
  }
});
